import React from "react";
import { Row, Col } from "antd";
import { useTranslation, Trans } from "react-i18next";
import { ReactComponent as CheckIcon } from "../../../../assets/icons/check-circle.svg";

import "../../../../assets/survey.scss";

const SurveyStepTwoRender = ({ purposeList, stepTwoChooseList, handleChangeChooseList }) => {
  const { t } = useTranslation(["loginAndSignUp"]);

  return (
    <div className="step-two-cont">
      <div className="mb-4 step-cont-title">
        <Trans i18nKey="loginAndSignUp:surveyStep2">
          Text
          <span className="text-primary step-cont-number fw-bolder">Text </span>
          Text
        </Trans>{" "}
        {t("surveyQuestion")}
      </div>
      <Row gutter={[16, 28]}>
        {purposeList.map(item => (
          <Col xs={12} sm={12} md={8} lg={6} key={item.key}>
            <div
              onClick={() => handleChangeChooseList(item.key)}
              className={`d-flex flex-column align-items-center overflow-hidden ${stepTwoChooseList.indexOf(item.key) !== -1 ? "active" : ""}`}
            >
              <div className="position-relative w-100 overflow-hidden">
                <img className="w-100 d-block" src={item.imgSrc} alt="survey" />
                <div className="mask position-absolute w-100 h-100 top-0 left-0 overflow-hidden d-flex align-items-center justify-content-center">
                  <CheckIcon className="check-icon" />
                </div>
              </div>
              <span className="mt-3 text-center px-2">{item.title}</span>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default SurveyStepTwoRender;
